<template>
  <FormulateInput
    v-bem="{
      inline,
      radio: as === 'radio',
      checkbox: as !== 'radio',
      fullWidth,
      spaceless,
      centered,
      noShadow,
      noSpacingAround,
    }"
    v-bind="{ ...$props, ...$attrs }"
    :validation-name="$attrs['validation-name'] || label"
    :label="elementLabel"
    :type="multiple ? 'checkbox' : 'radio'"
  />
</template>

<script>
import requiredLabelMixin from '../requiredLabelMixin';

export default {
  name: 'OptionsField',
  mixins: [requiredLabelMixin],
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: undefined,
    },
    validation: {
      type: [String, Array],
      default: 'required',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      required: true,
    },
    as: {
      type: String,
      default() {
        return this.multiple ? 'checkbox' : 'radio';
      },
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    spaceless: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    noShadow: {
      type: Boolean,
      default: false,
    },
    noSpacingAround: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';
@use "sass:map";

.options-field {
  margin-bottom: 0;

  >>> .form-check-label {
    @include utils.bs-media-breakpoint-down(md) {
      font-size: utils.f-rem-calc(14);
    }

    .form-text {
      display: block;
      font-size: inherit;
    }
  }

  @at-root #{&}--centered {
    width: fit-content;
    margin: 0 auto;
  }

  @at-root #{&}--spaceless {
    >>> .formulate-input-group {
      border-radius: utils.$bs-border-radius;
      box-shadow: utils.$bs-box-shadow;
      overflow-y: hidden;
    }

    >>> .formulate-input-group-item {
      margin-bottom: 0;
    }

    >>> .form-check--card {
      border-radius: 0;
      box-shadow: none;
    }
  }

  @include utils.bs-media-breakpoint-up(md) {
    >>> .formulate-input-group {
      width: fit-content;
    }

    @at-root #{&}--full-width {
      >>> .formulate-input-group {
        width: initial;
      }
    }

    @at-root #{&}--inline {
      >>> .formulate-input-group {
        display: flex;
      }

      >>> .formulate-input-group-item {
        flex: 1;

        & + .formulate-input-group-item {
          margin-left: utils.f-rem-calc(24);
        }
      }
    }
  }

  @at-root #{&}--checkbox {
    >>> .form-check-input {
      border-radius: utils.$bs-form-check-input-border-radius;

      &:checked {
        background-image: utils.bs-escape-svg(
          utils.$bs-form-check-input-checked-bg-image
        );
      }
    }
  }

  @at-root #{&}--radio {
    >>> .form-check-input {
      border-radius: utils.$bs-form-check-radio-border-radius;

      &:checked {
        background-image: utils.bs-escape-svg(
          utils.$bs-form-check-radio-checked-bg-image
        );
      }
    }
  }

  @at-root #{&}--no-shadow {
    >>> .formulate-input-group {
      box-shadow: none !important;
    }
  }

  @at-root #{&}--no-spacing-around {
    >>> .form-check--card {
      padding-left: utils.f-rem-calc(24);
      padding-right: 0;
    }
  }
}
</style>
